import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/booking/bookingList.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getBookings = (_0) => __async(void 0, [_0], function* ({ lang, organizationId = "" }) {
  try {
    const locale = getLocaleOnly(lang);
    const data = yield fetchClient({
      url: `/user/booking-history?lang=${locale}&organization=${organizationId}`
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getBookingsException",
      context: { tags: { journey: "profile" } }
    });
  }
});
var getBluBookings = (_0) => __async(void 0, [_0], function* ({ lang, organizationId = "" }) {
  try {
    const locale = getLocaleOnly(lang);
    const data = yield fetchClient({
      url: `/user/booking-history-blu?lang=${locale}&organization=${organizationId}`
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getBluBookingsException",
      context: { tags: { journey: "profile" } }
    });
  }
});
var getHyExperiencesBookings = (_0) => __async(void 0, [_0], function* ({ lang, organizationId = "" }) {
  try {
    const locale = getLocaleOnly(lang);
    const data = yield fetchClient({
      url: `/halayalla/booking-history?lang=${locale}&organization=${organizationId}`
    });
    return { orders: data.data.map(hyExperienceToWbkAdapter), seasons: [] };
  } catch (error) {
    throw new Exception({
      error,
      name: "getHyExperiencesBookings",
      context: { tags: { journey: "profile" } }
    });
  }
});
var hyExperienceToWbkAdapter = (data) => {
  var _a;
  return {
    _id: data._id,
    type: "experience",
    status: (_a = data.status) == null ? void 0 : _a.toLowerCase(),
    total_price: data.total_price,
    order_date_time: Math.floor(new Date(data.created_at).getTime() / 1e3),
    has_transfered_tickets: false,
    survey_completed: true,
    survey_sent: true,
    event_url: "",
    current_time: 0,
    transfer_count: data.num_of_people,
    event: {
      _id: data.venue_id,
      title: data.venue_name,
      slug: "",
      poster: data.venue_image,
      venue: { city: data.venue_city },
      has_timeslots: true,
      start_date_time: 0,
      end_date_time: 0,
      status: "",
      tbc: false,
      venue_name: data.venue_name
    },
    total_tickets: data.transaction_products.length,
    tickets: data.time_slots.map((slot) => ({
      _id: slot.id,
      currency: data.currency,
      qty: +slot.num_of_people,
      price: slot.facility.price_per_slot.toString(),
      vat: slot.facility.vat_per_slot.toString(),
      qr_code: "",
      time_slot: { time_to: new Date(+slot.time.to * 1e3) },
      opentimeslot_end_date: { date: new Date(+slot.time.to * 1e3) },
      ticket_category: {
        _id: "",
        title: slot.facility.name,
        color: ""
      },
      total_price: slot.price,
      is_open_timeslot: false
    })),
    home_team: {
      _id: "",
      name: "",
      logo: ""
    },
    away_team: {
      _id: "",
      name: "",
      logo: ""
    }
  };
};

export {
  getBookings,
  getBluBookings,
  getHyExperiencesBookings
};
//# sourceMappingURL=chunk-XTIEVMBH.mjs.map